<div *appHasAnyAuthority="['LOGIN', 'HELP_1']" class="restaurant-dashboards">
    <h1>Restaurant</h1>
    <div class="nav-cards-container-lg">
        <mat-card *appHasAnyAuthority="['LOGIN', 'HELP_1']" [routerLink]="['device']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>healing</mat-icon>
                    Device Health
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>View a restaurants network devices and their data</p>
            </mat-card-content>
        </mat-card>
        <mat-card *appHideFromAnyAuthority="['HELP_1']" [routerLink]="['wan']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>healing</mat-icon>
                    WAN Health
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>View a restaurants WAN health KPIs and SLOs</p>
            </mat-card-content>
        </mat-card>
        <mat-card *appHasAnyAuthority="['LOGIN', 'FEATURE_TOGGLE']" [routerLink]="['lan']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>healing</mat-icon>
                    LAN Health
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>View a restaurants LAN health KPIs and SLOs</p>
            </mat-card-content>
        </mat-card>
        <mat-card *appHideFromAnyAuthority="['HELP_1']" [routerLink]="['wifi']" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>healing</mat-icon>
                    WiFi Health
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>View a restaurants WiFi health KPIs and SLOs</p>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div *appHideFromAnyAuthority="['HELP_1', 'FEATURE_TOGGLE']" class="chain-wide-dashboards">
    <h1>Chain Wide</h1>
    <div class="nav-cards-container-lg">
        <mat-card [routerLink]="'chain-health'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>healing</mat-icon>
                    Chain Health
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>View device information for all restaurants in the chain</p>
            </mat-card-content>
        </mat-card>
        <mat-card [routerLink]="'location'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>store</mat-icon>
                    Location Overview
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Operator information, restaurant status, address, and time zone</p>
            </mat-card-content>
        </mat-card>
        <mat-card [routerLink]="'location-closures'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>location_off</mat-icon>
                    Permanent Closures
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>See locations that have been permanently closed or terminated</p>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div *appHideFromAnyAuthority="['HELP_1', 'FEATURE_TOGGLE']" class="device-dashboards">
    <h1>Devices</h1>
    <div class="nav-cards-container-lg">
        <mat-card [routerLink]="'chain-wide-merakis'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>settings_ethernet</mat-icon>
                    Meraki
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>All Meraki managed switches</p>
            </mat-card-content>
        </mat-card>
        <mat-card [routerLink]="'chain-wide-cradlepoints'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>signal_cellular_alt</mat-icon>
                    Cradlepoint
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>All Cradlepoint routers</p>
            </mat-card-content>
        </mat-card>
        <mat-card [routerLink]="'chain-wide-fortigates'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>router</mat-icon>
                    FortiGate
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>All FortiGate routers</p>
            </mat-card-content>
        </mat-card>
        <mat-card [routerLink]="'chain-wide-mists'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>wifi</mat-icon>
                    Mist
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>All Mist access points</p>
            </mat-card-content>
        </mat-card>
        <mat-card [routerLink]="'cp-speed-tests'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>trending_up</mat-icon>
                    Cradlepoint Speed Tests
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Metrics & reports on Cradlepoint speeds</p>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div *appHideFromAnyAuthority="['HELP_1', 'FEATURE_TOGGLE']" class="device-dashboards">
    <h1>Circuits</h1>
    <div class="nav-cards-container-lg">
        <mat-card [routerLink]="'lumen-diagnostics'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>help_center</mat-icon>
                    Lumen Diagnostics
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>View diagnostic information for Lumen circuits</p>
            </mat-card-content>
        </mat-card>
        <mat-card *appHasAnyAuthority="['ADMIN']" [routerLink]="'circuit-map'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>map</mat-icon>
                    Circuit Map
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Circuit types and speeds in a map view</p>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<div *appHasAnyAuthority="['ADMIN']" class="device-dashboards">
    <h1>Executive Reporting</h1>
    <div class="nav-cards-container-lg">
        <mat-card [routerLink]="'availability'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>trending_up</mat-icon>
                    Availability
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Chainwide device availability</p>
            </mat-card-content>
        </mat-card>
        <mat-card [routerLink]="'kevlar2-progress'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>screen_rotation</mat-icon>
                    Kevlar2 Refresh
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>Progress on the Kevlar2 Refresh Project</p>
            </mat-card-content>
        </mat-card>
    </div>
</div>
<!-- <div *appHideFromAnyAuthority="['HELP_1', 'FEATURE_TOGGLE']" class="device-dashboards">
    <h1>Metrics</h1>
    <div class="nav-cards-container-lg">
        <mat-card [routerLink]="'fortinet-metrics'" class="z-depth">
            <mat-card-header>
                <mat-card-title>
                    <mat-icon>help_center</mat-icon>
                    Fortinet Availability
                </mat-card-title>
            </mat-card-header>
            <mat-card-content>
                <p>View availability metrics for Fortinet routers</p>
            </mat-card-content>
        </mat-card>
    </div>
</div> -->